import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Cart } from '../../icons';

import './style.css'
import WarnIcon from '../../icons/WarnIcon';
import { WARNING_RED } from '../../config/colors';

const STYLES = {
  warnIcon: { width: 'auto', height: 25 },
};

class CartCounter extends Component {
  getWarnIconColor = () => {
    const { warnIconColor } = this.props;

    return warnIconColor || WARNING_RED;
  }

  render() {
    const {
      color,
      isOverLimits,
      cartIconStyle,
    } = this.props;

    return (
      <div className="cart-wrapper">
        <Cart className="cart-icon" color={color} style={cartIconStyle} />
        {!isOverLimits && (
          <div className="counter-wrapper">
            <span>{this.props.cartQuantity}</span>
          </div>
        )}
        {isOverLimits && (
          <div className="counter-wrapper">
            <WarnIcon style={STYLES.warnIcon} color="red" />
          </div>
        )}
      </div>
    );
  }
}

export default CartCounter;

CartCounter.propTypes = {
  color: PropTypes.string.isRequired,
  isOverLimits: PropTypes.bool.isRequired,
  warnIconColor: PropTypes.string,
  cartIconStyle: PropTypes.shape({}).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/CartCounter/CartCounter.jsx